import React, {useState} from "react";
import Button from "reactstrap/lib/Button";
import Form from "reactstrap/lib/Form";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalHeader from "reactstrap/lib/ModalHeader";
import {t} from "react-switch-lang";
import './Modals.css';

import {MarkAllNotificationAsReadApi} from "../../services/notifications/NotificationsApi";
import Exclusion from "./img/Exclusion 2.svg";

export function MarkAllNotificationAsRead(props) {
    const [modal, setModal] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const userModal = () => setModal(!modal);

    const handleSubmit = event => {
        event.preventDefault();
        MarkAllNotificationAsReadApi().then((res) => {
            props.setRowChanged()
            setModal(!modal)
            setIsButtonDisabled(false);
        })
    }

    return (
        <>
            <button className="editNotification" onClick={userModal}>
                {`${t('buttons.markAllAsRead')}`}
            </button>
            <Modal isOpen={modal} toggle={userModal} className="modal-md modalDelete" backdrop="static">
                <ModalHeader toggle={userModal} >
                    <div>{t('buttons.markAllAsRead')} </div>
                    <img src={Exclusion} alt="Exclusion" onClick={userModal} style={{cursor: "pointer"}} />
                </ModalHeader>
                <ModalBody className="d-flex flex-row">
                    <div>
                        <div className="row">
                            <div className="py-2 my-2">
                                <h3> {`${t('question.markAllAsRead')} ?`}</h3>
                            </div>
                            <div className="container-fluid decorationLine"></div>
                            <div className="offset-5">
                                <Button onClick={userModal} className="danger cancelButton">
                                    {t('buttons.cancelBtn')}
                                </Button>
                            </div>
                            <div className="text-right">
                                <Form onSubmit={(e) => handleSubmit(e)} noValidate className="d-flex justify-content-between">
                                    <Button className="primary deleteButton" disabled={isButtonDisabled}>
                                        {t("buttons.save")}{" "}
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}
